import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Illimité — symbole infini duotone */
export const UnlimitedIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Halo menthe en arrière-plan */}
      <path
        d="M5 12a4 4 0 0 1 7-2.5L12 12l-1 1.5A4 4 0 1 1 5 12z M19 12a4 4 0 0 1-7 2.5L12 12l1-1.5A4 4 0 1 1 19 12z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.55"
      />
      {/* Trait infini */}
      <path
        d="M7 9a3.5 3.5 0 0 1 5 3 3.5 3.5 0 0 0 5 3 3.5 3.5 0 0 0 0-6 3.5 3.5 0 0 0-5 3 3.5 3.5 0 0 1-5 3 3.5 3.5 0 0 1 0-6z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinejoin="round"
      />
    </svg>
  ),
);
UnlimitedIcon.displayName = "UnlimitedIcon";
